/* ==========================================================
FREE ITEMS ENTFERNEN sobald Threshold unterschritten wurde
========================================================== */

(function() {

  function getFreeItemConfigs() {
    const itemEls = document.querySelectorAll('.free-item-values');
    if (!itemEls.length) return [];

    return Array.from(itemEls).map((el) => ({
      variantId: parseInt(el.dataset.variantId, 10),
      threshold: parseInt(el.dataset.freeItemThreshold, 10),
      title: el.dataset.productTitle || 'Free Item'
    }));
  }

  async function fetchCurrentCart() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Cart fetch failed');
      return await response.json();
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  async function removeLineItem(lineItemKey) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: lineItemKey,
          quantity: 0
        })
      });

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      
      if (window.Shopify && window.Shopify.onCartUpdate) {
        window.Shopify.onCartUpdate(); 
      }
      
    } catch (e) {
      console.error(e);
    }
  }

  async function cleanUpFreeItems() {
    const freeItems = getFreeItemConfigs();
    if (!freeItems.length) return;

    const cart = await fetchCurrentCart();
    if (!cart || !cart.items) return;

    for (const config of freeItems) {
      const itemInCart = cart.items.find(item => item.variant_id === config.variantId);

      if (!itemInCart) continue;

      const currentCartTotal = cart.total_price;
      const itemLinePrice = itemInCart.final_line_price || 0; 
      const subtotalWithoutThisItem = currentCartTotal - itemLinePrice;

      if (subtotalWithoutThisItem < config.threshold) {
        await removeLineItem(itemInCart.key);
      }
    }
  } 

  document.addEventListener('DOMContentLoaded', () => {
    cleanUpFreeItems();
  });

  let timeout;
  document.addEventListener('cart:change', () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      cleanUpFreeItems(); 
    }, 200);
  });

  document.addEventListener('cart:updated', () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      cleanUpFreeItems(); 
    }, 200);
  }); 
})();

/* ==========================================================
GEWINNSPIEl - GiveawayNinja - NACH ENDE ENTFERNEN

Updated Entries Badge nach Quantity Change
========================================================== */

/* ==========================================================
GIVEAWAY CART BADGE – Lose lokal aus Warenkorbsumme (sofort)
========================================================== */
(function () {
  let busy = false;

  function writeBadge(cents) {
    const badge = document.querySelector('#cart-drawer .giveaway-badge-cart-api')
              || document.querySelector('.giveaway-badge-cart-api');
    if (!badge) return;

    const tpl = badge.dataset.entriesLabel || '{entries} Lose';
    const entries = Math.floor((cents || 0) / 100); // 1 Los je vollem Euro
    const block = badge.querySelector('.giveaway-total-entries-block');
    const text  = block && block.querySelector('.badge-entries-text');
    if (!text) return;

    text.textContent = tpl.replace('{entries}', entries);
    if (block) block.style.display = '';
    badge.style.display = '';
  }

  async function update() {
    if (busy) return;
    busy = true;
    try {
      const res = await fetch('/cart.js');          // lokaler, schneller Endpunkt
      if (!res.ok) return;
      const cart = await res.json();
      // Basis-Betrag: ggf. auf cart.total_price umstellen, falls die Lose am rabattierten Preis hängen
      writeBadge(cart.items_subtotal_price);
    } catch (e) {
      // still: bei Fehler bleibt die letzte Zahl stehen
    } finally {
      busy = false;
    }
  }

  let t;
  function schedule() { clearTimeout(t); t = setTimeout(update, 60); }

  document.addEventListener('cart:change', schedule);
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart:refresh', schedule); // dein Free-Item-Cleanup feuert das

  // Einmal initial setzen (falls der Drawer schon offen ist)
  update();
})(); 